export enum Unit {
  UNIT = "UNIT", // countable items
  G = "G", // grams (weight)
  ML = "ML", // milliliters (volume)
  CM = "CM", // centimeters (length)
  SQCM = "SQCM" // square centimeters (area)
  // Add more units as needed: KG, L, M, SQM, etc.
}
